import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button, Menu, MenuItem as MuiMenuItem } from "@mui/material";
import { MenuRight } from "mdi-material-ui";
import { forwardRef, useState } from "react";
import { Link } from "react-router";
export const CascadingMenu = forwardRef(function CascadingMenuWithRef({ menu, onClose, children, ...props }, ref) {
    const [anchorEl, setAnchorEl] = useState(null);
    function handleClick(event) {
        setAnchorEl(event.currentTarget);
    }
    function handleClose() {
        setAnchorEl(null);
    }
    function handleLinkClick() {
        handleClose();
        if (onClose) {
            onClose();
        }
    }
    return (_jsxs(_Fragment, { children: [typeof children === "function" ? (children(menu.link ? handleLinkClick : handleClick)) : (_jsx(Button, { ...props, onClick: handleClick, children: children })), menu.subMenu && (_jsx(Menu, { ref: ref, open: !!anchorEl, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: menu.component !== "button"
                    ? {
                        vertical: "top",
                        horizontal: "right",
                    }
                    : {
                        vertical: "bottom",
                        horizontal: "left",
                    }, children: menu.subMenu.map((item) => item.title && (_jsx(CascadingMenu, { menu: item, onClose: handleLinkClick, children: (onClick) => (_jsxs(MuiMenuItem, { onClick: onClick, ...(item.link && { component: Link, to: item.link }), children: [_jsx(Box, { sx: { width: "100%" }, children: item.title }), item.subMenu && _jsx(MenuRight, {})] })) }, item.title))) }))] }));
});
//# sourceMappingURL=CascadingMenu.js.map